import Carousel from "../Carousel";
import SectionHdr from "../SectionHeader";

export default function DynamicBookSlider({ title, books = [], selectedBooks = [], itemLimit = 8, onView, cart, addCart }) {
    const manualBooks = selectedBooks.slice(0, itemLimit);
    
    // Fallback if no books are manually selected by admin
    let displayBooks = manualBooks.length > 0 ? manualBooks : books.slice(0, itemLimit);

    if (displayBooks.length === 0) return null;

    return (
        <section className="section" style={{
            background: "white",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B"
        }}>
            <Carousel
                books={displayBooks}
                onView={onView}
                cart={cart}
                addCart={addCart}
                renderHeader={(dots) => <SectionHdr pill={title.toUpperCase()} rightContent={dots} />}
            />
        </section>
    );
}
